import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { useAuthStore } from './stores/authStore'
import './styles/global.scss'

// Suppress harmless ResizeObserver errors from Vuetify components.
// This happens when the "Accommodation Types" select field changes size due to the user
// selecting a value.
const resizeObserverErrorHandler = (event) => {
  if (
    event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    event.message === 'ResizeObserver loop limit exceeded'
  ) {
    const isFromResizeObserver = event.filename === '' && event.lineno === 0 && event.colno === 0
    if (isFromResizeObserver) {
      event.stopImmediatePropagation()
      event.preventDefault()
    }
  }
}
window.addEventListener('error', resizeObserverErrorHandler)

// Alternative approach: Ignore all ResizeObserver errors
const debounce = (callback, delay) => {
  let tid
  return function (...args) {
    const ctx = this
    tid && clearTimeout(tid)
    tid = setTimeout(() => {
      callback.apply(ctx, args)
    }, delay)
  }
}

const _ = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ {
  constructor(callback) {
    callback = debounce(callback, 20)
    super(callback)
  }
}

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)

// Mount app immediately, then initialize auth in background.
// This avoids a blank page while waiting for API calls (/Users/me, MSAL).
// The router guard handles redirecting unauthenticated users to /login.
app.mount('#app')

const authStore = useAuthStore()
authStore.initialize().catch(error => {
  console.error('Auth initialization failed:', error)
})
